import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { NgApexchartsModule } from 'ng-apexcharts';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { JerSuggestMultiselectComponent } from './jer-suggest-multiselect/jer-suggest-multiselect.component';
import { transformExactSearchPipe } from './pipes/transform-exactSearch.pipe';
import { transformSemanticOrStringSearchPipe } from './pipes/transform-semanticOrStringSearch.pipe';



// TRANSLATION

import { TranslateModule } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { ClickOutsideModule } from 'ng-click-outside';


@NgModule({ declarations: [
        AppComponent,
        JerSuggestMultiselectComponent,
        transformExactSearchPipe,
        transformSemanticOrStringSearchPipe,
    ],
    bootstrap: [AppComponent], 
    imports: [BrowserModule,
        AppRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        NgApexchartsModule,
        // https://github.com/ngx-translate/core
        TranslateModule.forRoot({
            defaultLanguage: 'en'
        }),
        ClickOutsideModule], 
    providers: [
        ...provideTranslateHttpLoader({
            prefix: 'assets/i18n/',
            suffix: '.json'
        }),
        provideHttpClient(withInterceptorsFromDi())
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA] })
export class AppModule { }
